module.exports = __webpack_public_path__ + "static/GDGD-85d9e294ffe41f4c3c3b28d75a01b48f.svg";